<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 系统设置
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>

                <div class='handle-input' style='width: 210px'>污水罐报警阈值(%)</div>

                <el-input v-model='value' placeholder='请输入污水罐报警阈值' class='handle-input mr10'></el-input>
                <el-button type='primary'  @click='handleSearch'>保存</el-button>
            </div>
            <div class='handle-box'>

                <div class='handle-input' style='width: 210px'>超速预警阈值(km/h)</div>

                <el-input v-model='speedValue' placeholder='超速预警阈值' class='handle-input mr10'></el-input>
                <el-button type='primary'  @click='updateSpeedAlarm'>保存</el-button>
            </div>

            <div class='handle-box'>

                <div class='handle-input' style='width: 210px'>管理员接收污水罐预警开关</div>
                <el-switch
                    v-model="valueBol"
                    active-color="#13ce66"
                    inactive-color="#eaeaea">
                </el-switch>
                <el-button type='primary'  @click='saveAdminPhone' style='margin-left: 270px'>保存</el-button>
            </div>

        </div>

        <!-- 编辑弹出框 -->

        <!-- 添加用户 -->
    </div>
</template>

<script>
import { formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            speedValue:20,
            valueBol:false,
            radio: '1',
            fileList: [],

            options: [],
            value:"",
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            roleTypeOptions: [{ 'label': '超级管理员', 'value': 0 },
                { 'label': '财务', 'value': 1 },
                { 'label': '销售', 'value': 2 },
                { 'label': '企业主', 'value': 3 }],


            createForm: {
                'concatPhone': '',
                'concatName': '',
                'name': '',
                'covenantUrl': '',
                'legalPersonUrl': '',
                'orzUrl': '',
                'isCustomerService': '1',
                'provinceId': '',
                'cityId': ''

            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1

        };
    },
    created() {
        this.getData();
        // this.getCity();
    },


    methods: {
        indexMethod(index) {
            return index + 1;
        },
        handlePreview(file) {

        },
        uploadFileCovenant(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.createForm.covenantUrl = res.data.data;
                    that.form.covenantUrl = res.data.data;
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileLegalPerson(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.legalPersonUrl = res.data.data;
                    that.form.legalPersonUrl = res.data.data;
                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        uploadFileOrzUrl(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.orzUrl = res.data.data;
                    that.form.orzUrl = res.data.data;

                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        }
        ,
        // 获取 easy-mock 的模拟数据
        getData() {
            let that = this;


            this.http.getToken('/SewageTank/getAlarmThreshold', this.query).then(res => {
                    if (res.code == 0) {
                        that.value = res.data.threshold;
                        that.valueBol = res.data.valueBol
                        that.speedValue = res.data.speedValue


                    }
                },
                err => {

                });


        },
        getCity() {
            let that = this;


            this.http.getToken('serviceProvider/getCity', this.query).then(res => {
                    if (res.code == 0) {
                        that.options = res.data;

                    }
                },
                err => {

                });
        },
        // 触发搜索按钮
        handleSearch() {
            let that = this;

            this.http.postToken('SewageTank/updateAlarmThreshold', { 'threshold': this.value}).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('更新成功');
                    }
                },
                err => {

                });
        },
        updateSpeedAlarm() {
            let that = this;

            this.http.postToken('SewageTank/updateSpeedAlarm', { 'speed': this.speedValue}).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('更新成功');
                    }
                },
                err => {

                });
        },

        saveAdminPhone() {
            let that = this;

            this.http.postToken('SewageTank/updateAlarmAdmin', { 'valueBol': this.valueBol}).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('更新成功');
                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.postToken('user/delUserById', { 'id': id, 'status': 1 }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        editUserHttp(params) {
            let that = this;
            this.http.post('user/updatePwdById', params).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('重置成功');
                    }
                },
                err => {

                });
        }
        ,

        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.createForm = {};
            this.value = [];
            this.addVisible = true;


        },

        addUserHttp() {
            let that = this;
            this.http.post('user/createMgLogin', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                }

            });
        }
        ,
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 0) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 2 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('serviceProvider/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.form = JSON.parse(JSON.stringify(row));
            if (typeof row.covenantUrl != 'null') {
                this.form['covenantUrlList'] = [{ 'url': row.covenantUrl }];
            }

            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$set(this.tableData, this.idx, this.form);
            this.editUserHttp(this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
